import React, { useState } from 'react';

import { DatePicker, Segmented } from 'antd';

import { getMoment, getNow, toISODate, toISODateTime } from '@libs/NwMoment';

import ModelsAvailabilityEventDatesTags from '@components/ContactsSelector/ModelsSelector/ModelsAvailability/ModelsAvailabilityEventDatesTags';
import EventDateTimePicker from '@components/EventDateTimePicker/EventDateTimePicker';
import { NwButton } from '@components/Gui/NwButton';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const { RangePicker } = DatePicker;

// Shared form component for date selection
const ModelsAvailabilityForm = ({ availabilityRange, checkDates, eventDates, onUpdate, isFetchingAvailability }) => {
    const [selectedRange, setSelectedRange] = useState(availabilityRange);
    const [selectedDates, setSelectedDates] = useState(checkDates);

    const handleUpdateSingleDate = (timeframe) => {
        setSelectedRange('Day');
        setSelectedDates([toISODateTime(timeframe.startdate), toISODateTime(timeframe.enddate)]);
    };

    const handleUpdatePeriod = (dates) => {
        setSelectedRange('Period');
        setSelectedDates(dates.map((date) => toISODate(date)));
    };

    const handleUpdateRange = (range) => {
        setSelectedRange(range);
        switch (range) {
            case 'Day':
                // const firstDateDay = getMoment(selectedDates[0]).startOf('day');
                // const lastDateDay = getMoment(selectedDates[0]).endOf('day');
                const firstDateDay = getNow(true);
                const lastDateDay = getNow().endOf('day');
                setSelectedDates([toISODateTime(firstDateDay), toISODateTime(lastDateDay)]);
                break;
            case 'Period':
                //first and last date of the period
                //const firstDate = getMoment(selectedDates[0]).startOf('day');
                //const lastDate = getMoment(selectedDates[selectedDates.length - 1]).endOf('day');
                //start with today and tomorrow
                const firstDate = getNow();
                const lastDate = getNow().add(1, 'day');
                setSelectedDates([toISODate(firstDate), toISODate(lastDate)]);
                break;
            case 'Dates':
                onUpdate(range, null);
                break;
        }
    };

    const onConfirm = () => {
        onUpdate(selectedRange, selectedDates);
    };

    const segmentedOptions = [
        { label: 'Day', value: 'Day' },
        { label: 'Period', value: 'Period' },
        ...(eventDates && eventDates.length > 0 ? [{ label: 'Event Dates', value: 'Dates' }] : []),
    ];

    return (
        <>
            <div>
                <Segmented
                    options={segmentedOptions}
                    onChange={handleUpdateRange}
                    value={selectedRange}
                    disabled={isFetchingAvailability}
                />
            </div>
            <div>
                {selectedRange === 'Day' ? (
                    <EventDateTimePicker
                        defaultStartDate={selectedDates[0] ? getMoment(selectedDates[0]) : null}
                        defaultEndDate={selectedDates[1] ? getMoment(selectedDates[1]) : null}
                        startFullDay
                        eventMode="singledate"
                        layout="vertical"
                        onChange={handleUpdateSingleDate}
                        disabled={isFetchingAvailability}
                    />
                ) : selectedRange === 'Period' ? (
                    <RangePicker
                        autoComplete="off"
                        style={{ width: '100%' }}
                        format="MMM DD, YYYY"
                        value={selectedDates ? [getMoment(selectedDates[0]), getMoment(selectedDates[1])] : null}
                        onChange={handleUpdatePeriod}
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        disabled={isFetchingAvailability}
                    />
                ) : (
                    <ModelsAvailabilityEventDatesTags eventDates={eventDates} />
                )}
            </div>
            <div>
                {selectedRange !== 'Dates' && (
                    <NwButton
                        icon={byPrefixAndName.fasl['calendar-check']}
                        size="small"
                        primary
                        onClick={onConfirm}
                        label="check availability"
                    />
                )}
            </div>
        </>
    );
};

export default ModelsAvailabilityForm;
